import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Form, Segment, Button, Divider, } from 'semantic-ui-react';
import Select from 'react-select';
import FileUploader from 'react-firebase-file-uploader';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import axios from 'axios'
import { firebaseAuth, toCurrency, pythonApiIp, firebaseStorage, logComponentLoad } from '../../../../config/constants.js'

//import { getShirtTypeDownDown } from '../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getShirtTypesToDisplay } from '../LargeProjects/ApiUtils'
import * as UiConsts from '../../../../config/UiConstants';
import ViewUraAssess from './ViewUraAssess'

class AddUraAssess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dailyExpenseOptions: [],
            dailyExpense: '',
            newDailyExpense: '',
            newDailyExpense: '',
            itemArray: [],
            shirtTypeOptions: [],
            dateNum: '',
            qty: '',
            price: '',
            notes: '',
            loading: false,
        }
    }


    componentDidMount() {
        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        //getPrintValues("dailyExpenses", this.setDailyExpenseOptions);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("uras1 +++++++++:removeListener");

            if (user) {
                console.log("uras12 user is:" + user.email);

                if (user.email) {
                    console.log("uras13 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("uras14 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ uras15 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "AddUraAssess");
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }



    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('cv32 You\'ve sss:', value);
        console.log('cv32 You\'ve selected:', value.value + " " + value.category);


        this.setState({
            dailyExpense: value.value,
            newDailyExpense: value.label,
        });
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("uras15 e.target.name:" + e.target.name);
        console.log("uras15 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("uras16 date:" + date);
        console.log("uras17 date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }


    addUraAss = () => {
        console.log("uras18 ++++++++:sendList");
        console.log("date:" + this.state.dateNum);

        this.setState({ loading: true });

        axios.post(pythonApiIp + 'addUraAss', {
            apiKey: "ad#4fsdUUddf",
            custom_ref:this.state.custom_ref,
            decl_ref:this.state.decl_ref,
            asses_ref:this.state.asses_ref,
            num_packages:this.state.num_packages,
            dclrnt_tin:this.state.dclrnt_tin,
            dclrnt_name:this.state.dclrnt_name,
            import_duty:this.state.import_duty,
            vat_asses:this.state.vat_asses,
            withldng_tax:this.state.withldng_tax,
            inf_levy:this.state.inf_levy,
            total_taxes:this.state.total_taxes,
            prn_code:this.state.prn_code,
            prn_srch_code:this.state.prn_srch_code,
            assDocLink:this.state.assDocLink,
            itemType:this.state.itemType,
            assDocLink:this.state.docUrl,
            printed_on:this.state.dateNum,
            enteredBy:this.state.user.email
        })
            .then((response) => {
                console.log(response.data);
                this.setState({ loading: false });
                console.log("uras181 result:" + response.data.result);

                if (response.data.result) {

                    alert(response.data.message);
                    this.resetFeilds();
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    resetFeilds = () => {
        this.setState({
            apiKey: "ad#4fsdUUddf",
            custom_ref:'',
            decl_ref:'',
            asses_ref:'',
            num_packages:'',
            dclrnt_tin:'',
            dclrnt_name:'',
            import_duty:'',
            vat_asses:'',
            withldng_tax:'',
            inf_levy:'',
            total_taxes:'',
            prn_code:'',
            prn_srch_code:'',
            assDocLink:'',
            docUrl:'',
            itemType:'',
            assDocLink:'',
            printed_on:'',
            enteredBy:this.state.user.email
        })
    }

    /**
    * HANDLE THE FILE UPLOADING..
    */
    handleUploadStart = (file) => {
        console.log("uras3 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("uras31 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("uras32 docUrl is:" + url);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("uras33 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("uras34 +++++++: updateWhenFileUploadComplete");
        console.log("uras35 uploaded:" + uploaded);
        console.log("uras36 fileName:" + fileName);
        console.log("uras37 url:" + url)
    }

    render() {

        const sendButtonUI = this.state.dateNum != ''
            // && this.state.dailyExpense != ''
            // && this.state.qty != ''
            // && this.state.price != ''
            // && this.state.notes != ''
            // && this.state.newDailyExpense != ''
            ? <Button color='green'> SEND ASSESS </Button>
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const fileUploadUI = <div>
            <h4>DOCLINK: {this.state.docUrl}</h4>
            <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
        </div>

        const viewAssesUi = this.state.user  
            ?<ViewUraAssess user={this.state.user} />
            :''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("DailyExpenses_ivan")
            ? <div>

                {viewAssesUi}

                <Segment>
                    <Form fixed onSubmit={this.addUraAss}>
                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {/* <label>{this.state.dailyExpense} </label> */}


                        {/* custom_ref */}
                        <Form.Field>
                            <label>custom_ref: {this.state.custom_ref} </label>
                            <Form.Input
                                fluid
                                name={'custom_ref'}
                                value={this.state.custom_ref}
                                icon='arrow alternate circle right'
                                iconPosition='left'
                                placeholder='custom_ref'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        {/* decl_ref */}
                        <Form.Field>
                            <label>decl_ref: {this.state.decl_ref} </label>
                            <Form.Input
                                fluid
                                name={'decl_ref'}
                                value={this.state.decl_ref}
                                icon='expand arrows alternate'
                                iconPosition='left'
                                placeholder='decl_ref'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        {/* decl_ref */}
                        <Form.Field>
                            <label>asses_ref: {this.state.asses_ref} </label>
                            <Form.Input
                                fluid
                                name={'asses_ref'}
                                value={this.state.asses_ref}
                                icon='sort'
                                iconPosition='left'
                                placeholder='asses_ref'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>


                        {/* num_packages */}
                        <Form.Field>
                            <label>num_packages: {this.state.num_packages} </label>
                            <Form.Input
                                fluid
                                name={'num_packages'}
                                value={this.state.num_packages}
                                icon='text height'
                                iconPosition='left'
                                placeholder='num_packages'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* dclrnt_tin */}
                        <Form.Field>
                            <label>dclrnt_tin: {this.state.dclrnt_tin} </label>
                            <Form.Input
                                fluid
                                name={'dclrnt_tin'}
                                value={this.state.dclrnt_tin}
                                icon='film'
                                iconPosition='left'
                                placeholder='dclrnt_tin'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* dclrnt_name */}
                        <Form.Field>
                            <label>dclrnt_name: {this.state.dclrnt_name} </label>
                            <Form.Input
                                fluid
                                name={'dclrnt_name'}
                                value={this.state.dclrnt_name}
                                icon='sync alternate'
                                iconPosition='left'
                                placeholder='dclrnt_name'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        {/* import_duty */}
                        <Form.Field>
                            <label>import_duty: {toCurrency(this.state.import_duty)} </label>
                            <Form.Input
                                fluid
                                name={'import_duty'}
                                value={this.state.import_duty}
                                icon='address book'
                                iconPosition='left'
                                placeholder='import_duty'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* vat_asses */}
                        <Form.Field>
                            <label>vat_asses: {toCurrency(this.state.vat_asses)} </label>
                            <Form.Input
                                fluid
                                name={'vat_asses'}
                                value={this.state.vat_asses}
                                icon='balance scale'
                                iconPosition='left'
                                placeholder='vat_asses'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* withldng_tax */}
                        <Form.Field>
                            <label>withldng_tax: {toCurrency(this.state.withldng_tax)} </label>
                            <Form.Input
                                fluid
                                name={'withldng_tax'}
                                value={this.state.withldng_tax}
                                icon='chart pie'
                                iconPosition='left'
                                placeholder='withldng_tax'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* inf_levy */}
                        <Form.Field>
                            <label>inf_levy: {toCurrency(this.state.inf_levy)} </label>
                            <Form.Input
                                fluid
                                name={'inf_levy'}
                                value={this.state.inf_levy}
                                icon='add user'
                                iconPosition='left'
                                placeholder='inf_levy'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>

                        {/* total_taxes */}
                        <Form.Field>
                            <label>total_taxes: {toCurrency(this.state.total_taxes)} </label>
                            <Form.Input
                                fluid
                                name={'total_taxes'}
                                value={this.state.total_taxes}
                                icon='coffee'
                                iconPosition='left'
                                placeholder='total_taxes'
                                onChange={this.handleTextInputChange}
                                type='number'
                            />
                        </Form.Field>


                        {/* prn_code */}
                        <Form.Field>
                            <label>prn_code: {this.state.prn_code} </label>
                            <Form.Input
                                fluid
                                name={'prn_code'}
                                value={this.state.prn_code}
                                icon='copy outline'
                                iconPosition='left'
                                placeholder='prn_code'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>


                        {/* prn_srch_code */}
                        <Form.Field>
                            <label>prn_srch_code: {this.state.prn_srch_code} </label>
                            <Form.Input
                                fluid
                                name={'prn_srch_code'}
                                value={this.state.prn_srch_code}
                                icon='globe'
                                iconPosition='left'
                                placeholder='prn_srch_code'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        {/* itemType */}
                        <Form.Field>
                            <label>prn_srch_code: {this.state.itemType} </label>
                            <Form.Input
                                fluid
                                name={'itemType'}
                                value={this.state.itemType}
                                icon='folder open'
                                iconPosition='left'
                                placeholder='itemType'
                                onChange={this.handleTextInputChange}
                                type='text'
                            />
                        </Form.Field>

                        <Divider horizontal>{'DOC UPLOAD'}</Divider>
                        {fileUploadUI}

                        {sendButtonUI}

                    </Form>
                </Segment>

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            <h1>Enter Ura Assess</h1>
            {wholeUI}

        </div>);
    }
}

export default AddUraAssess;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ura/AddUraAssess.js